import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.tsx';
import { themes, ThemeName } from '../../theme.ts';

const ThemeSettings: React.FC = () => {
  const { themeName, setThemeName } = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setThemeName(e.target.value as ThemeName);
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6" style={{ color: themes[themeName].colors.text }}>Theme Settings</h1>
      <div className="max-w-md">
        <label
          htmlFor="theme-select"
          className="block mb-2 text-sm font-medium"
          style={{ color: themes[themeName].colors.textSecondary }}
        >
          Select Theme:
        </label>
        <select
          id="theme-select"
          value={themeName}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          style={{
            borderColor: themes[themeName].colors.border,
            backgroundColor: themes[themeName].colors.card,
            color: themes[themeName].colors.text,
          }}
        >
          {Object.keys(themes)
            .filter((t) => !['mild', 'darker', 'brand'].includes(t))
            .map((theme) => (
              <option key={theme} value={theme}>
                {theme.charAt(0).toUpperCase() + theme.slice(1)}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default ThemeSettings;
